import React, { useState, useContext } from 'react';
import axios from 'axios';
import logo from '../assets/images/hey-visuals-logo.png';
import { Link } from 'react-router-dom';
import GoogleSignInPage from './GoogleSignIn';
import { LoadingContext } from './LoadinContext';
const ResetPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleResetPassword = async (e) => {
        e.preventDefault();
        if (!email) {
            setError('Email is required.');
            return;
        }
        const baseUrl = `${process.env.REACT_APP_BASE_URL}/confirmresetpassword`
        setLoading(true);
        setError('');
        setStatus('');

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/password/email`,
                { email, app_url: baseUrl }
            );

            if (response.data.status === 200) {
                setStatus(response.data.message || 'Password reset link sent successfully.');
                setEmail('');
            } else if (response.data.status === 422) {
                setError(
                    response.data?.message?.email || 'An error occurred. Please try again later.'
                );
            } else {
                setError(response.data.message || 'Failed to send reset link.');
            }
        } catch (err) {
            setError(
                err || 'An error occurred. Please try again later.'
            );
        } finally {
            setLoading(false);
        }
    };

    const { loadingGoogle } = useContext(LoadingContext);

    const isEmailValid = () => {
        const emailRegex = email;
        return emailRegex;
    };

    return (
        <div
            className="d-flex flex-column flex-lg-row "
            style={{ backgroundColor: '#F7F8FB', height: '100vh' }}
        >
            {/* Left Section */}
            <div className="d-flex flex-lg-row-fluid">
                <div className="d-none d-md-flex flex-column flex-center pb-0 w-100">
                    <img className="theme-light-show w-250px mx-auto pb-10"
                        src={logo} alt="Logo" />
                    <section className="HomeVideoSection">
                        <div className="HomeVideoOuter">
                            <div className="video-wrapper">
                                <div
                                    className="wistia_responsive_padding"
                                    style={{ padding: '56.25% 0 0 0', position: 'relative' }}
                                >
                                    <div
                                        className="wistia_responsive_wrapper"
                                        style={{
                                            height: '100%',
                                            left: 0,
                                            position: 'absolute',
                                            top: 0,
                                            width: '100%',
                                        }}
                                    >
                                        <iframe
                                            src="https://fast.wistia.net/embed/iframe/dajig0c7nu?seo=true&videoFoam=true"
                                            title="How Hey Visuals AI Works? Video"
                                            allow="autoplay; fullscreen"
                                            frameBorder="0"
                                            scrolling="no"
                                            className="wistia_embed"
                                            style={{ width: '100%', height: '100%' }}
                                        ></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            {/* Right Section */}
            <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12" >
                <div className="bg-body d-flex flex-column flex-center rounded-4 w-md-600px p-10">
                    <div className="d-flex flex-center flex-column align-items-stretch h-lg-100 w-md-400px">
                        <div className="d-flex flex-center flex-column flex-column-fluid">
                            <img
                                className="d-md-none d-lg-none d-xl-none theme-light-show mb-3 w-75"
                                src={logo}
                                alt="Mobile Logo"
                            />

                            <form className="form w-100" noValidate onSubmit={handleResetPassword}>
                                <div className="text-center mb-11">
                                    <h1 className="text-dark fw-bolder mb-3">Reset Password</h1>
                                    <div className="text-gray-500 fw-semibold fs-6">
                                        Your Social Campaigns
                                    </div>
                                </div>

                                {/* Google Sign-in */}
                                <GoogleSignInPage />
                                {/* <GoogleSignIn
                                            onSuccess={handleGoogleSuccess}
                                            onFailure={handleGoogleFailure}
                                        /> */}

                                <div className="separator separator-content my-8">
                                    <span className="w-125px text-gray-500 fw-semibold fs-7">
                                        Reset
                                    </span>
                                </div>

                                {/* Success Message */}
                                {status && (
                                    <div className="alert alert-success reset-password-msg">
                                        {status}
                                    </div>
                                )}

                                {/* Email Input */}
                                <div className="fv-row mb-8">
                                    <input
                                        type="email"
                                        placeholder="Email"
                                        name="email"
                                        className={`form-control bg-transparent ${error ? 'is-invalid' : ''
                                            }`}
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                    {error && <span className="text-danger">{error}</span>}
                                </div>

                                {/* Submit Button */}
                                <div className="d-grid mb-10">
                                    <button type="submit"
                                        className="btn btn-theme btn-shadow login-btn"
                                        disabled={loading || loadingGoogle || !isEmailValid()} >
                                        {loading || loadingGoogle ? (
                                            loadingGoogle ? (
                                                <>
                                                    Please wait...{' '}
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </>
                                            ) : (
                                                <>
                                                    Please wait...{' '}
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </>
                                            )
                                        ) : (
                                            'Send Password Reset Link'
                                        )}
                                    </button>
                                </div>

                                <div className="text-gray-500 text-center fw-semibold fs-6">
                                    Already have an Account?{' '}
                                    <Link to="/login" className="link-primary">
                                        Sign in
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordPage;
